import { createSlice } from "@reduxjs/toolkit";
import { getCompaniesThunk, getProductsByCompanyThunk, getProductsDataByProductId } from "../thunk/recommendation.thunk";

type Company = {
  companyId: string;
  companyName: string;
};

type Product = {
  productId: string
  displayName: string;
};

type RecommendationState = {
  companies: Company[];
  products: {
    insaRecommendation: Product[];
    general: Product[];
  } | null;
  loading: boolean;
  error: string | null;
  benefitSummary: any
  benefitSummaryLoading: boolean;
};

const initialState: RecommendationState = {
  companies: [],
  products: null,
  loading: false,
  error: null,
  benefitSummary: null,
  benefitSummaryLoading: false,
};

const recommendationSlice = createSlice({
  name: "recommendation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Companies
      .addCase(getCompaniesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompaniesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload;
      })
      .addCase(getCompaniesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Products
      .addCase(getProductsByCompanyThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.products = null;
      })
      .addCase(getProductsByCompanyThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getProductsByCompanyThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.products = null;
      })

      // BenefitSummary
      .addCase(getProductsDataByProductId.pending, (state) => {
        state.benefitSummary = {};
        state.benefitSummaryLoading = true;
      })
      .addCase(getProductsDataByProductId.fulfilled, (state, action) => {
        state.benefitSummary = action.payload || {};
        state.benefitSummaryLoading = false;
      })
      .addCase(getProductsDataByProductId.rejected, (state) => {
        state.benefitSummary = {};
        state.benefitSummaryLoading = false;
      });

  }
});

export default recommendationSlice.reducer;
